// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Fx","author":"e_Gx","container":"e_Hx","image":"e_Ix","uiHolder":"e_Jx"};